import React from "react";
import { Link } from "react-router-dom";
import { fonts } from "../theme";

export default function SiteFooter() {
  return (
    <footer className="border-top bg-body-tertiary mt-auto py-3 px-3">
      <div className="container-fluid px-0 px-md-3 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2">
        <span className="small text-secondary text-center text-sm-start" style={{ fontFamily: fonts.body }}>
          © {new Date().getFullYear()} WIBIL · Workforce Information Bureau (India) Limited · GoldPE.AI
        </span>
        <Link
          to="/privacy-policy"
          className="small fw-semibold text-primary text-decoration-none"
          style={{ fontFamily: fonts.body }}
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
